module.exports = __webpack_public_path__ + "img/warning-gray-icon.a6e735e2.svg";